import useApiAtendimento from "./atendimento";

export function useFetchPessoasFisicas(id) {
  return useApiAtendimento("/pessoa-fisica/" + id);
}
